import React from "react";
import MortgageApplication from "./_index";

const ExtPropertyEligibilityView = () => {
  return (
    <MortgageApplication
      propertyId={0} 
      price={undefined}
      setMortgageSuccess={undefined}
      property={undefined}
    />
  );
}; 

export default ExtPropertyEligibilityView;
